'use client';

import {useTranslation} from 'react-i18next';
import type {DetailPageAnalytics, TrackedItem} from '../../analytics';
import {useLocale} from '../../i18n';
import type {NewsCardView} from '../../model';
import {newsForProjectHref} from '../../routing';
import {ListingCard, ListingCarousel, newsCardProps} from '../listing';
import {Section} from '../primitives';

export interface DetailNewsCarouselProps {
  articles: NewsCardView[];
  analytics: DetailPageAnalytics;
  parentTracked: TrackedItem;
  viewAllProjectId?: string;
}

export function DetailNewsCarousel({articles, analytics, parentTracked, viewAllProjectId}: DetailNewsCarouselProps) {
  const {t} = useTranslation();
  const locale = useLocale();
  if (articles.length === 0) {
    return null;
  }
  const viewAllHref = viewAllProjectId ? newsForProjectHref(locale, viewAllProjectId) : undefined;

  return (
    <Section tone="base">
      <ListingCarousel
        title={t('latest_news_title')}
        viewAll={
          viewAllHref
            ? {
                label: t('view_all'),
                href: viewAllHref,
                onClick: () => {
                  analytics.viewAll(parentTracked, 'latest_news');
                },
              }
            : undefined
        }
      >
        {articles.map(article => (
          <ListingCard
            key={article.uuid}
            {...newsCardProps(article, locale)}
            onClick={() => {
              analytics.carouselCard({id: article.uuid, name: article.title}, 'latest_news');
            }}
          />
        ))}
      </ListingCarousel>
    </Section>
  );
}

DetailNewsCarousel.displayName = 'DetailNewsCarousel';
